import { GLOBAL_STATUS } from "../system/global-enums";
import { ROUTES } from "./route.constants";
import { customerConstants } from "./customer.constants";

export const loginConstants = {
  USER_LOGIN: "USER_LOGIN",
  USER_LOGOUT: "USER_LOGOUT",
  LOGIN_STATUS: {
    ...GLOBAL_STATUS,
  },
  EMAIL_VERIFIED: "EMAIL_VERIFIED",
  UPDATE_CURRENT_ADDRESS: "UPDATE_CURRENT_ADDRESS",
};

export const signupConstants = {
  USER_SIGNUP: "USER_SIGNUP",
  SIGNUP_STATUS: {
    ...GLOBAL_STATUS,
  },
};

export const selectionConstants = {
  CUSTOMER: "CUSTOMER",
  SHUTTERB: "SHUTTERB",
};

export const redirectAfterLogin = "redirectAfterLogin";

export const deeplinkPaths = [
  [
    `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}`,
    `${customerConstants.RECAP_FEEDBACK}`,
  ],
  [
    `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}`,
    `${customerConstants.TIP_YOUR_SHUTTERB}`,
  ],
  [
    `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}`,
    `${customerConstants.ACCESS_GALLERY}`,
  ],
  [
    `${ROUTES.CUSTOMER_DASHBOARD_TAB}${ROUTES.MY_EVENTS}`,
    `${customerConstants.REVIEW_YOUR_SHUTTERB}`,
  ],
];
